import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  Box,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Checkmark from '@square-icons/react/24/UI/check';
import { MarketAccessory, MarketHeader, MarketRow } from '@market/react';
import { getLocalePath } from 'utilities/locales';
import { buildSignInLink, buildSignUpLink } from 'utilities/links';

const FinancingModal = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { open, handleClose, isLoggedIn } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      fullScreen={useMediaQuery(theme.breakpoints.down('sm'))}
      open={open}
      onClose={handleClose}
      data-market-features="typography,html-styles"
    >
      <MarketHeader
        showNavigation
        onMarketHeaderNavigate={handleClose}
        style={{ margin: theme.spacing(4, 4, 0) }}
      >
        <h1>{t('productPage.financingModal.title')}</h1>
      </MarketHeader>
      {!isLoggedIn && (
        <Box sx={{ margin: theme.spacing(1, 4, 0) }}>
          <Trans
            class="paragraph-30"
            i18nKey="productPage.financingModal.requireLogin"
          >
            <a
              href={buildSignInLink({ returnTo: true })}
              target="_blank"
              rel="noreferrer"
            />
            <a
              href={buildSignUpLink({ returnTo: true })}
              target="_blank"
              rel="noreferrer"
            />
          </Trans>
        </Box>
      )}
      <DialogContent sx={{ pt: 0, pb: 4, px: 4 }}>
        <Box sx={{ py: 2 }}>
          {[1, 2, 3].map((i) => (
            <MarketRow key={`checklist${i}`}>
              <MarketAccessory slot="leading-accessory">
                <Checkmark fill={theme.color.blue} />
              </MarketAccessory>
              <p slot="label" className="medium-30">
                {t(`productPage.financingModal.checklist${i}.title`)}
              </p>
              <p slot="subtext">
                {t(`productPage.financingModal.checklist${i}.body`)}
              </p>
            </MarketRow>
          ))}
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Box component="p" className="medium-30" sx={{ mb: 2 }}>
            {t('productPage.financingModal.cta')}
          </Box>
          <p className="paragraph-10">
            <Trans i18nKey={'productPage.financingModal.body'}>
              <a
                href={`/help${getLocalePath()}/contact`}
                target="_blank"
                rel="noreferrer"
              />
            </Trans>
          </p>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FinancingModal;
